import React from "react";
import PropTypes from "prop-types";
import { isEmpty } from "lodash";
import classNames from "classnames";
import { getProductKeyFromHandle } from "../../utils/shop";

// Components
import Link from "../Atoms/Link";
import Paragraph from "../Atoms/Paragraph";
import ImageWithLabel from "../Molecules/ImageWithLabel";
import { ImgixImage } from "../Utils/ImgixImage";
import ShopifyAddToCartCta from "../Utils/ShopifyAddToCartCta";

// Stylesheets
import "./FeaturedSleepProductSection.scss";

// Constants
import { IMGIX_BASE_PATH } from "../../utils/constants";
import { EVENT_PROPERTIES_VALUES } from "../../types/Amplitude";

export const ProductDetails = ({ staticData, sleepProducts }) => {
  if (isEmpty(sleepProducts)) {
    return null;
  }

  const { handle, features, image, intro, editorial } = staticData;
  const key = getProductKeyFromHandle(handle);
  const productShopifyData = sleepProducts[key];

  return (
    <div className="product_details">
      <h3 className="heading h3_text is_mobile_and_tablet">{intro}</h3>
      <div className="image_container">
        <ImgixImage
          className="product_image"
          sizes={{ default: "80vw", tablet: "468px", desktop: "365px" }}
          htmlAttributes={{ loading: "lazy" }}
          src={image.src}
          alt={image.alt}
        />

        <ShopifyAddToCartCta
          productShopifyData={productShopifyData}
          trackingProps={{
            sectionName: EVENT_PROPERTIES_VALUES.Collection_Featured_Product,
          }}
        />
      </div>

      <div className="product_info">
        <h3 className="heading h3_text is_desktop_only">{intro}</h3>
        <ul className="unstyled_list product_features">
          {features.map((feature, idx) => (
            <li key={idx} className="feature">
              <ImageWithLabel
                label={feature.label}
                src={`${IMGIX_BASE_PATH}/${feature.icon}`}
                alt={feature.alt}
                stackedOnDesktop
              />
            </li>
          ))}
        </ul>
        <Paragraph className="editorial_copy">{editorial}</Paragraph>
        <Link to={`/${handle}`} linkType="primary" className="learn_more_link">
          Learn More
        </Link>
      </div>
    </div>
  );
};

ProductDetails.propTypes = {
  staticData: PropTypes.shape({
    handle: PropTypes.string.isRequired,
    intro: PropTypes.string.isRequired,
    features: PropTypes.array.isRequired,
    image: PropTypes.shape({
      src: PropTypes.string.isRequired,
      alt: PropTypes.string.isRequired,
      sizes: PropTypes.object.isRequired,
    }),
    editorial: PropTypes.string.isRequired,
  }).isRequired,
  sleepProducts: PropTypes.object.isRequired,
};

export const FeaturedSleepProductSection = ({ staticData, sleepProducts }) => {
  const classes = classNames(
    "featured_sleep_product_section",
    "section",
    "full_width_section",
    `product_${staticData.handle}`
  );

  return (
    <section className={classes}>
      <div className="container">
        <ProductDetails staticData={staticData} sleepProducts={sleepProducts} />
      </div>
    </section>
  );
};

FeaturedSleepProductSection.propTypes = {
  staticData: PropTypes.object.isRequired,
  sleepProducts: PropTypes.object.isRequired,
};

export default FeaturedSleepProductSection;
